import React from 'react';
import { Img } from 'react-image';

interface Props {
	showShortlisted?: boolean;
	positionTitle: string;
}

const NoRecommendedCandidatesState = ({ positionTitle, showShortlisted = false }: Props) => {
	return (
		<div className="flex flex-col items-center justify-center">
			<div className="px-8">
				<div className="flex justify-center">
					<Img
						loading="lazy"
						src="/assets/noApplicationsEmptyState.svg"
						alt="noApplicationsEmptyState"
						width="160"
						height="160"
					/>
				</div>

				<div className="text-center mt-4 text-base font-medium">
					No {showShortlisted ? 'matched candidates' : 'recommendations'} yet!
				</div>
				<div className="text-center mt-2 text-sm font-normal text-[#555770] dark:text-[#C7C9D9] max-w-[350px]">
					{showShortlisted
						? 'Start shortlisting candidates to start the process.'
						: `It appears that we couldn't generate any recommendations for this job position at the moment.`}{' '}
					Contact{' '}
					<a
						className="text-[#6698FA] underline"
						href={`mailto:support@levelup.inc?Subject=No%recommendations%for%${positionTitle}`}
					>
						support team
					</a>
				</div>
			</div>
		</div>
	);
};

export default NoRecommendedCandidatesState;
